var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.5386,
    y1: 186.2675,
    x2: 599.4586,
    y2: 186.2675,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7F3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61DB99"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M390.979,512H121.018c-19.675,0-36.31-14.568-38.905-34.071L44.001,191.552 c-3.131-23.526,15.172-44.427,38.905-44.427h346.185c23.733,0,42.036,20.901,38.905,44.427l-38.112,286.377 C427.289,497.432,410.654,512,390.979,512z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8071,
    y1: 93.723,
    x2: 254.8071,
    y2: 410.223,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M390.979,512c19.675,0,36.31-14.568,38.905-34.071l38.112-286.377 c3.131-23.526-15.172-44.427-38.905-44.427H82.906c-23.733,0-42.036,20.901-38.905,44.427l8.984,67.507l0.281,0.083L306.124,512 H390.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8071,
    y1: 50.433,
    x2: 254.8071,
    y2: -4.197,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M79.371,457.331l2.742,20.599c2.595,19.502,19.23,34.07,38.905,34.07h269.962 c19.675,0,36.31-14.568,38.905-34.071l2.742-20.599H79.371V457.331z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8136,
    y1: 243.073,
    x2: 254.8136,
    y2: 51.543,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#FF4C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 223.624,
    y: 147.125,
    style: {
      fill: "url(#SVGID_4_)"
    },
    width: 64.763,
    height: 364.875
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.6187,
    y1: 107.5846,
    x2: 279.9586,
    y2: 424.0846,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M468.003,191.552l-38.121,286.382c-2.59,19.494-19.224,34.065-38.903,34.065H288.385V147.128 h140.701C452.82,147.128,471.133,168.03,468.003,191.552z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8136,
    y1: 40.283,
    x2: 254.8136,
    y2: 11.583,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 223.624,
    y: 457.326,
    style: {
      fill: "url(#SVGID_6_)"
    },
    width: 64.763,
    height: 54.674
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.3589,
    y1: 368.2433,
    x2: 491.5089,
    y2: 91.1033,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7F3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#61DB99"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M450.954,260.11H61.043c-17.627,0-31.916-14.289-31.916-31.916v-81.431 c0-17.627,14.289-31.916,31.916-31.916h389.91c17.627,0,31.916,14.289,31.916,31.916v81.431 C482.87,245.82,468.58,260.11,450.954,260.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6811,
    y1: 342.9255,
    x2: 343.3211,
    y2: 239.2855,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#FF4C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 223.624,
    y: 114.849,
    style: {
      fill: "url(#SVGID_8_)"
    },
    width: 64.763,
    height: 145.267
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 444.9566,
    y1: 122.3862,
    x2: 344.3567,
    y2: 438.8862,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M482.872,146.758v81.435c0,17.63-14.287,31.917-31.917,31.917H288.385V114.842h162.571 C468.586,114.842,482.872,129.141,482.872,146.758z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.407,
    y1: 278.3528,
    x2: 284.287,
    y2: 455.7308,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61DB99",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009E74"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M403.194,114.847H108.939c0.887,5.055,1.959,10.114,3.224,15.179 c1.92,7.684,6.088,14.121,11.576,18.896l111.187,111.187h216.027c17.627,0,31.916-14.29,31.916-31.916v-33.672L403.194,114.847z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.6278,
    y1: 404.142,
    x2: 85.6978,
    y2: 494.292,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#FF4C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M112.182,28.122c5.575-22.313,30.023-34.235,51.063-24.947 c15.067,6.651,29.558,15.371,42.811,22.66c12.431,6.836,21.431,13.784,29.622,20.616c20.354,16.978,20.354,48.271,0,65.248 c-8.191,6.832-17.191,13.781-29.622,20.616c-13.254,7.287-27.744,16.009-42.811,22.659c-21.04,9.287-45.489-2.633-51.063-24.946 C103.673,95.965,103.672,62.188,112.182,28.122z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.6986,
    y1: 373.603,
    x2: 187.0386,
    y2: 433.363,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M235.679,111.697c6.483-5.408,10.893-12.271,13.246-19.659 c-37.514,3.36-96.121,16.072-118.237,61.671c9.671,5.17,21.576,6.11,32.558,1.262c15.067-6.651,29.558-15.371,42.811-22.66 C218.488,125.478,227.489,118.53,235.679,111.697z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.8407,
    y1: 425.1603,
    x2: 285.1908,
    y2: 505.4333,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M141.206,76.11c0,15.007,1.778,56.294,43.112,68.318c7.52-4.097,14.803-8.3,21.739-12.115 c12.431-6.836,21.431-13.784,29.622-20.616c11.41-9.517,16.42-23.531,15.039-37.001c0,0-21.669-11.703-31.293-16.364 C167.427,33.15,141.206,55.002,141.206,76.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.9882,
    y1: 404.1435,
    x2: 423.9182,
    y2: 494.2935,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    style: {
      stopColor: "#FF4C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F59500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M399.815,28.122C394.24,5.809,369.792-6.113,348.751,3.174 c-15.067,6.651-29.558,15.371-42.811,22.66c-12.431,6.836-21.431,13.784-29.622,20.616c-20.355,16.978-20.355,48.271,0,65.248 c8.191,6.832,17.191,13.781,29.622,20.616c13.254,7.287,27.744,16.009,42.811,22.659c21.04,9.287,45.489-2.633,51.064-24.946 C408.324,95.965,408.325,62.188,399.815,28.122z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.9187,
    y1: 373.603,
    x2: 322.5687,
    y2: 433.363,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5D00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D54003"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M276.318,111.697c-6.483-5.408-10.893-12.271-13.246-19.659 c37.514,3.36,96.121,16.072,118.237,61.671c-9.671,5.17-21.576,6.11-32.558,1.262c-15.067-6.651-29.558-15.371-42.811-22.66 C293.509,125.478,284.508,118.53,276.318,111.697z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.769,
    y1: 425.1635,
    x2: 224.429,
    y2: 505.4365,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    d: "M370.791,76.11c0,15.007-1.778,56.294-43.112,68.318c-7.52-4.097-14.803-8.3-21.739-12.115 c-12.431-6.836-21.431-13.784-29.622-20.616c-11.41-9.517-16.42-23.531-15.039-37.001c0,0,21.669-11.703,31.293-16.364 C344.57,33.15,370.791,55.002,370.791,76.11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.6086,
    y1: 415.9927,
    x2: 203.8186,
    y2: 434.5847,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE3F45",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE3F45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    d: "M276.318,111.697c8.191,6.832,17.191,13.781,29.622,20.616 c13.254,7.287,27.744,16.009,42.811,22.66c17.738,7.83,37.897,0.585,47.129-15.25l-97.29-97.29 c-2.404-2.604-5.055-4.974-7.897-7.103c-5.3,3.717-9.958,7.435-14.375,11.119C255.964,63.428,255.964,94.72,276.318,111.697z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.5886,
    y1: 488.343,
    x2: 287.0686,
    y2: 400.863,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#FF4C54"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    cx: 256,
    cy: 81.739,
    r: 57.966
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/icon-gift.6159c62b1780918d38d5345e675d6ed2.svg";
export { ForwardRef as ReactComponent };